"use strict";

var FlatPicker = function () {

  var handleDatePickers = function () {
    if (!jQuery().flatpickr) {
      return;
    }

    $('.date-picker').flatpickr({
      enableTime: false,
      dateFormat: "d-m-Y",
    });

    $('.date-picker-min').flatpickr({
      enableTime: false,
      dateFormat: "d-m-Y",
      minDate: "today"
    });

    $('.date-picker-inline').flatpickr({
      enableTime: false,
      dateFormat: "d-m-Y",
      minDate: "today",
      inline: true
    });

    $('.date-picker-range').flatpickr({
      mode: 'range',
      enableTime: false,
      dateFormat: "d-m-Y",
      locale: {
        rangeSeparator: ' <=> '
      }
    });

    $('.date-picker-filter').flatpickr({
      enableTime: false,
      dateFormat: "d-m-Y",
      onChange: function(selectedDates) {
        if (selectedDates) {
          var date = new Date(selectedDates);
          var year = date.toLocaleString("default", { year: "numeric" });
          var month = date.toLocaleString("default", { month: "2-digit" });
          var day = date.toLocaleString("default", { day: "2-digit" });
          var formattedDate = year + "-" + month + "-" + day;
          $('#profile-display-date').val(formattedDate);
          $('#form_search').submit();
        }
      }
    });
  };

  var handleTimePickers = function () {
    if (!jQuery().flatpickr) {
      return;
    }

    $(".timepicker-24").flatpickr({
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      time_24hr: true
    });

  };

  return {
    //main function to initiate the module
    init: function () {
      handleDatePickers();
      handleTimePickers();
    }
  };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = FlatPicker;
}

jQuery(document).ready(function() {
  FlatPicker.init();
});